// 代理门户通知提示音轮询 hook（fleet sound-agent 2026-09-28）：
// 60s 轮询 GET /notices/unread-count，未读数较上次「可信快照」增加即响。
// 提示音口径 canonical = web/admin/src/lib/reviewSound.ts（纯函数复用 lib/noticeSound.ts）。
// 接口失败/非 ok → 计数不可信（null），不响、不更新快照；首快照不响。
// 单实例挂载：仅 Sidebar.tsx（RequireAuth 布局内常驻），禁止在 App.tsx 等处重复挂载导致双响。
import { useEffect, useRef } from 'react';
import { fetchNoticeUnreadCount } from '@/api/notice';
import { playNoticeSound, shouldAlertNoticeIncrease } from '@/lib/noticeSound';

/** 提示音轮询间隔：新通知到达后 60s 内响（与 admin useReviewBadges 同间隔） */
const NOTICE_POLL_MS = 60_000;

export function useNoticeSound(): void {
  /** 上次「可信」未读数快照；null = 尚无可信快照（不响） */
  const lastTrustedCountRef = useRef<number | null>(null);

  useEffect(() => {
    // 竞态保护：卸载后返回的旧响应不得再判定/写快照
    let stale = false;

    const load = async () => {
      let count: number | null = null;
      try {
        const res = await fetchNoticeUnreadCount();
        if (stale) return;
        // ok:false（401/5xx 等）→ null 不可信
        count = res.ok ? (res.data.unreadCount ?? null) : null;
      } catch {
        count = null; // 网络异常 → 不可信
      }
      if (stale) return;
      if (shouldAlertNoticeIncrease(lastTrustedCountRef.current, count)) {
        playNoticeSound();
      }
      if (count != null) {
        lastTrustedCountRef.current = count;
      }
    };

    void load();
    const timer = window.setInterval(load, NOTICE_POLL_MS);

    return () => {
      stale = true;
      window.clearInterval(timer);
    };
  }, []);
}
